/**
 * Firebase configuration
 * Contains all Firebase-related configuration values
 */

import { FirebaseOptions } from "firebase/app";

export const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyCQFV7Mgj8B7qHz9aQR7CIul-INKv4dgdo",
  authDomain: "collegiate-nfl-impact.firebaseapp.com",
  projectId: "collegiate-nfl-impact",
  storageBucket: "collegiate-nfl-impact.appspot.com",
  messagingSenderId: "514358742000",
  appId: "1:514358742000:web:795548bb5a0f0b6fc4ab35",
  measurementId: "G-R3L9CJ0MT8",
};




